import { requestHelpers } from '../../helpers';

const actions = {
    GET_LOCATIONS_DATA: 'GET_LOCATIONS_DATA',
    SET_LOCATIONS_DATA: 'SET_LOCATIONS_DATA',
    GET_EXPERTISE: 'GET_EXPERTISE',
    SET_EXPERTISE: 'SET_EXPERTISE',
    GET_INDUSTRIES: 'GET_INDUSTRIES',
    SET_INDUSTRIES: 'SET_INDUSTRIES',
    GET_REMUNERATION_TYPES: 'GET_REMUNERATION_TYPES',
    SET_REMUNERATION_TYPES: 'SET_REMUNERATION_TYPES',
    GET_SECTORS: 'GET_SECTORS',
    SET_SECTORS: 'SET_SECTORS',
    TOGGLE_COUNTRY_SELECTOR: 'TOGGLE_COUNTRY_SELECTOR',
};

function getLocations() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_LOCATIONS_DATA,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/locations/countries' )
            .then( ( response ) => {
                return dispatch( {
                    type: actions.SET_LOCATIONS_DATA,
                    locations: response.data,
                } );
            } );
    }
}

function getExpertise() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_EXPERTISE,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/job/expertise' )
            .then( ( response ) => {

                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );

                dispatch( {
                    type: actions.SET_EXPERTISE,
                    expertise: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}

function getIndustries() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_INDUSTRIES,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/job/industries' )
            .then( ( response ) => {

                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );

                dispatch( {
                    type: actions.SET_INDUSTRIES,
                    industries: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}

function getRemunerationTypes() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_REMUNERATION_TYPES,
        } );

        requestHelpers
            .authenticatedGetRequest( '/jobs/remuneration-types' )
            .then( ( response ) => {
                return dispatch( {
                    type: actions.SET_REMUNERATION_TYPES,
                    remuneration_types: response.data,
                } );
            } );
    }
}

function getSectors() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_SECTORS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/job/sectors' )
            .then( ( response ) => {

                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );

                dispatch( {
                    type: actions.SET_SECTORS,
                    sectors: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}

function toggleCountry( countryId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.TOGGLE_COUNTRY_SELECTOR,
            countryId,
        } );
    };
}



module.exports = {
    actions,
    getLocations,
    getExpertise,
    getIndustries,
    getRemunerationTypes,
    getSectors,
    toggleCountry,

};



// WEBPACK FOOTER //
// src/client/actions/common/search.js